// extracted by mini-css-extract-plugin
module.exports = {"logo":"FormHeader_logo__zjSUe"};